export default __webpack_public_path__ + "static/media/websiteHackathon.1f2bc043.jpeg";